import {useAuth0} from '@auth0/auth0-react'
import {Avatar} from '@mantine/core'
import {mapInitials} from './mapper/mapInitials.ts'

export const UserAvatar = () => {
  const {user} = useAuth0()

  return <Avatar src={user?.picture}>{user?.name && mapInitials(user.name)}</Avatar>
}
